import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/park/coupon/issue/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/park/coupon/giveout/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/park/coupon/giveout/remove', qs.stringify(params),options);

export const cancel = (params, options) =>
request.post('/api/v4ward/park/coupon/giveout/cancel', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/park/coupon/giveout/save', params,options);



export const syncCouponGiveOut = (params, options) =>
  request.post('/api/v4ward/park/coupon/giveout/sync', qs.stringify(params),options);


  // 商家下拉框
  export const shopSelections = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/shopSelections', Object.assign({}, options, { params }));

//  优惠劵下拉框
  export const getCouponShopRecordList = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/record/getCouponShopRecordList', Object.assign({}, options, { params }));

  //  新增
export const save = (params, options) =>
request.post('/api/v4ward/park/coupon/issue/save',params,options); 
  //  编辑
  export const update = (params, options) =>
  request.post('/api/v4ward/park/coupon/issue/update',params,options); 


  
  // 统计已使用商家优惠券
export const getCouponReceiveNumSumByShopId = (params, options) =>
request.get('/api/v4ward/park/coupon/issue/getCouponReceiveNumSumByShopId',Object.assign({}, options, { params }));

  
  // 统计商家优惠券总数
  export const getCouponSumByShopId = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/record/getCouponSumByShopId',Object.assign({}, options, { params }));